import _ from 'lodash';
import {AurDataGridColDef} from '../types/types';
import {GridRenderCellParams} from '@mui/x-data-grid';
import {t} from 'i18next';

/*
Column name for client management table
*/
export const MANAGE_CLIENTS_TABLE_WIDTH = 1292;

export const getClientManagementColumns = (): AurDataGridColDef[] => [
  {
    field: 'name',
    headerName: t('clientManagement.clientName'),
    flex: 0.304, // 400/1312 base size ratio as per figma
    sortable: true,
  },
  {
    field: 'clientCode',
    headerName: t('clientManagement.id'),
    flex: 0.091, // 120/1312 base size ratio as per figma
    sortable: false,
  },
  {
    field: 'type',
    headerName: t('clientManagement.type'),
    flex: 0.091, // 120/1312 base size ratio as per figma
    sortable: false,
  },

  {
    field: 'projects',
    headerName: t('clientManagement.projects'),
    sortable: false,
    flex: 0.51, // 670/1312 base size ratio as per figma
    isBorderNotRequired: true,
    renderCell: (params: GridRenderCellParams) => {
      // 24 is left 16 and 8 right padding of cell
      // 50 is space for show +1 at end of cell
      const projectNameWidth = params.colDef.computedWidth - (24 + 50);
      const result = getProjectStringForFit(
        params.row?.projects ?? [],
        projectNameWidth
      );

      return !_.isEmpty(result.visibleProjects) ? (
        <div
          className="project-name-cell"
          style={{
            height: '100%',
            alignItems: 'center',
          }}
        >
          <span
            className="data-wrap"
            style={{width: projectNameWidth, lineHeight: 1.5}}
          >
            {result.visibleProjects}
          </span>
          {result.remainingCount > 0 && (
            <span
              className="plus-count-text"
              style={{lineHeight: 1.5}}
            >{`${result.remainingCount}+`}</span>
          )}
        </div>
      ) : null;
    },
  },
];

/**
 *
 * @param projects list of projects for dispaly
 * @param cellWidth width container where project will be display
 * @returns Based on cell width and projects, calculte the number of project name can be
 * display under available width and return remaining project count which can't be display
 */
export const getProjectStringForFit = (
  projects: {projectName: string}[],
  cellWidth: number
) => {
  const container = document.createElement('span');
  container.style.visibility = 'hidden';
  container.style.whiteSpace = 'nowrap';
  container.style.font = '14px Inter';
  container.style.fontWeight = '400';
  container.style.lineHeight = '20px';
  document.body.appendChild(container);

  const visibleProjects = [];
  let remainingCount = 0;

  for (const item of projects) {
    container.innerText = visibleProjects.concat(item.projectName).join(', ');
    visibleProjects.push(item.projectName);
    if (container.offsetWidth > cellWidth) {
      remainingCount = projects.length - visibleProjects.length;
      break;
    }
  }

  document.body.removeChild(container);

  return {
    visibleProjects: visibleProjects.join(', '),
    remainingCount,
  };
};

export const PERMISSION_GRP_CLIENT_PERMISSIONS = [
  'REPORT_PROJECT_TRACKER_VIEW',
  'REPORT_BUDGET_TRACKER_VIEW',
];
